import { ChangeDetectionStrategy, Component, OnInit, computed, signal } from '@angular/core';
import { UserApi } from 'api/user/user-api.js';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { FormSaveHandler } from 'lib/ui/form/form-save-button.component.js';
import { catchError, map } from 'rxjs';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';
import { loginEmailStoreKey } from './helpers/auth-page-setup.js';

@Component({
	templateUrl: './login.component.html',
	selector: 'mod-login',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LoginComponent extends CoreAppComponent implements OnInit {
	public readonly forgottenPasswordRouterLink: string = this.dependencies.navigateService
		.forgottenPasswordPage()
		.getUrl();

	public readonly form = {
		email: signal<string | undefined>(undefined),
		password: signal<string | undefined>(undefined)
	};

	public readonly saveHandler = computed<FormSaveHandler>(() => {
		const email = this.form.email();
		const password = this.form.password();

		const formData: UserApi.ISignInRequest = {
			email: email ?? '', // always allow logging in
			password: password ?? '', // always allow logging in
			timezone: this.getCurrentTimezone()
		};

		return this.dependencies.httpService
			.post<UserDb.IAuthUserResponse, UserApi.ISignInRequest>((builder) =>
				builder.withCustomApiRoute('user', 'login').withData(formData).build()
			)
			.pipe(
				map((response) => {
					// store login for future use
					this.dependencies.storageService.storeValue(loginEmailStoreKey, response.data.user.email);

					this.dependencies.authService.login(response.data.token);
					this.dependencies.navigateService.dashboardPage(response.data.user.userType).navigate();
				}),
				catchError((error) => {
					// clear password
					this.form.password.set('');
					throw error;
				})
			);
	});

	constructor() {
		super();
	}

	ngOnInit(): void {
		this.form.email.set(this.dependencies.storageService.getValue(loginEmailStoreKey));
	}

	private getCurrentTimezone(): string {
		return this.dependencies.timeService.currentZone.name;
	}
}
